export default "__VITE_ASSET__Cw8ArGWD__"